var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.298,
    height: 19.3,
    viewBox: "0 0 19.298 19.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "school",
    transform: "translate(0.15 -0.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15880",
    "data-name": "Path 15880",
    d: "M0,10.686c.115-.142.22-.295.348-.424.7-.708,1.409-1.407,2.108-2.116a.789.789,0,0,1,.61-.251c.816.009,1.633,0,2.449.006a.392.392,0,0,0,.307-.129c1-1,2-2,3-3.01a.453.453,0,0,0,.119-.285c.008-1.026,0-2.053.005-3.08A.576.576,0,0,1,9.6.74H12.98a.569.569,0,0,1,.651.644q0,1.1,0,2.208a.566.566,0,0,1-.651.643h-2.9a.584.584,0,0,0,.137.573c.994.974,1.974,1.962,2.954,2.949A.431.431,0,0,0,13.5,7.9c.8-.007,1.608,0,2.412-.007a.823.823,0,0,1,.642.263c.725.736,1.457,1.464,2.189,2.192a.609.609,0,0,1,.227.641.578.578,0,0,1-.569.412v.224c0,2.455,0,4.91,0,7.365A.72.72,0,0,1,18,19.74H1a.721.721,0,0,1-.412-.748c.01-2.457,0-4.915,0-7.372V11.4A.641.641,0,0,1,0,10.983v-.3Zm7.753,7.933v-.213q0-1.066,0-2.133a.556.556,0,0,1,.614-.623q1.132,0,2.263,0a.556.556,0,0,1,.616.621c0,.717,0,1.434,0,2.152v.191h1.271v-.18q0-4.795,0-9.589a.448.448,0,0,0-.122-.285c-.913-.924-1.832-1.84-2.75-2.758-.043-.043-.088-.083-.139-.131-.051.047-.1.087-.139.13Q7.985,7.178,6.606,8.553a.394.394,0,0,0-.126.308q0,4.776,0,9.553v.205H7.753Zm9.534-7.213h-3.64v7.206h3.64V11.4ZM5.344,18.619V11.407H1.719v7.211Zm-3.43-8.353h3.44V9.011c-.711,0-1.408,0-2.105,0a.205.205,0,0,0-.129.053c-.4.389-.787.782-1.206,1.2Zm15.181.006c-.425-.424-.817-.818-1.215-1.2a.288.288,0,0,0-.184-.054c-.636,0-1.272,0-1.909,0-.047,0-.094.009-.142.013v1.247h3.449ZM12.508,1.866H10.068V3.112h2.439ZM8.88,16.77v1.843h1.24V16.77Z",
    fill: "#161617",
    stroke: "#161617",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15882",
    "data-name": "Path 15882",
    d: "M158.16,145.14a1.746,1.746,0,1,1-1.75,1.737,1.742,1.742,0,0,1,1.75-1.737Zm.629,1.745a.633.633,0,1,0-.633.635.627.627,0,0,0,.633-.635Z",
    transform: "translate(-148.656 -137.241)",
    fill: "#161617",
    stroke: "#161617",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15883",
    "data-name": "Path 15883",
    d: "M156.381,242.11c0-.1,0-.2,0-.3a.554.554,0,0,1,1.107-.046,4.84,4.84,0,0,1,0,.684.554.554,0,0,1-1.106-.046c0-.1,0-.2,0-.3Z",
    transform: "translate(-148.628 -228.591)",
    fill: "#161617",
    stroke: "#161617",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15884",
    "data-name": "Path 15884",
    d: "M205.408,242.107c0,.1,0,.2,0,.3a.554.554,0,0,1-1.107.038,4.919,4.919,0,0,1,0-.684.554.554,0,0,1,1.106.035c0,.1,0,.21,0,.314Z",
    transform: "translate(-194.162 -228.585)",
    fill: "#161617",
    stroke: "#161617",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15885",
    "data-name": "Path 15885",
    d: "M300.729,242.11c0-.111-.005-.222,0-.333a.552.552,0,0,1,.51-.519.524.524,0,0,1,.568.424,3.587,3.587,0,0,1,0,.863.513.513,0,0,1-.589.414.546.546,0,0,1-.489-.516c-.006-.111,0-.222,0-.333Z",
    transform: "translate(-285.818 -228.593)",
    fill: "#161617",
    stroke: "#161617",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15886",
    "data-name": "Path 15886",
    d: "M301.8,302.358a3.4,3.4,0,0,1-.032.412.549.549,0,0,1-1.086-.083c-.009-.222-.009-.444,0-.665a.54.54,0,0,1,.491-.514.533.533,0,0,1,.592.417,3.23,3.23,0,0,1,.036.433Z",
    transform: "translate(-285.771 -285.855)",
    fill: "#161617",
    stroke: "#161617",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15887",
    "data-name": "Path 15887",
    d: "M61.318,242.086c0,.117.007.234,0,.351a.541.541,0,0,1-.5.5.51.51,0,0,1-.574-.411,3.633,3.633,0,0,1,0-.88.521.521,0,0,1,.56-.411.553.553,0,0,1,.515.515c.007.111,0,.222,0,.333Z",
    transform: "translate(-57.23 -228.574)",
    fill: "#161617",
    stroke: "#161617",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15888",
    "data-name": "Path 15888",
    d: "M61.307,302.37c0,.111.006.222,0,.333a.553.553,0,0,1-.517.513.523.523,0,0,1-.558-.414,3.662,3.662,0,0,1,0-.881.511.511,0,0,1,.577-.408.541.541,0,0,1,.5.507C61.314,302.135,61.307,302.253,61.307,302.37Z",
    transform: "translate(-57.219 -285.86)",
    fill: "#161617",
    stroke: "#161617",
    strokeWidth: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.7d2a8289f31c3c71306396ae3231481b.svg";
export { ForwardRef as ReactComponent };